import { Defect, DefectStatus } from "../../types/defect";
import { Tag } from "primereact/tag";

export const StatusBody = (defect: Defect) => {
    const { status } = defect;
    let severity = "success";

    if (status === DefectStatus["In Progress"]) {
        severity = "info";
    }

    if (
        status === DefectStatus.Rectified ||
        status === DefectStatus.Expired
    ) {
        severity = "warning";
    }

    if (status === DefectStatus.Open) {
        severity = "danger";
    }

    return (
        <div className="flex justify-content-center">
            <Tag severity={severity as any} value={DefectStatus[status]} />
        </div>
    );
};
